import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../services/global-data.service';

@Injectable()
export class NotificationService {

  constructor(
    private http: HttpClient,
    private global: GlobalDataService
  ) { }


  getNotification(filter: string){
    
    let addFilter: string="";
    
    switch (filter) {
      case 'unread':
      addFilter="?is_read=0";
        break;
      case 'read':
      addFilter="?is_read=1";
        break;
      case 'all':
      addFilter="";
        break;
    }
     return this.http.get(this.global.httpUrl+"notifications"+addFilter);
  }

  getUnreadCountNotifacation(){
    return this.http.get(this.global.httpUrl+"notifications/unread/count");
  }

  changeMessageToRead(id: string){
    return this.http.post(this.global.httpUrl+"notifications/"+id+"/read",{id: id});
  }
  

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/utils/notification/notification.service.ts